import { ref, watch, computed } from "@vue/composition-api";
import store from "@/store";

// Notification
import ToastificationContent from "@core/components/toastification/ToastificationContent.vue";
import { useToast } from "vue-toastification/composition";

export default function useFormsList() {
  // Use toast
  const toast = useToast();

  const refFormsListTable = ref(null);

  const styleColumns = {
        thClass: 'text-center',
        tdClass: 'text-center'
    }

  // Table Handlers
  let tableColumns = [
    { key: "start_date", sortable: true, label: "MES/AÑO <br> EVALUACIÓN", ...styleColumns },
    { key: "evidence_type", sortable: false, label: "TIPO DE SOLICITUD", ...styleColumns },
    { key: "state_name", sortable: true, label: "ESTADO", ...styleColumns },
    { key: "condition_name", sortable: true, label: "CONDICIÓN", ...styleColumns },
    { key: "actions", sortable: false, label: "OPCIONES", ...styleColumns },
  ];

  const perPage = ref(10);
  const totalForms = ref(0);
  const currentPage = ref(1);
  const perPageOptions = [5, 10, 15, 20];
  const sortBy = ref("start_date");
  const isSortDirDesc = ref(true);

  const conditionsFilter = ref(null);

  const dataMeta = computed(() => {
    const localItemsCount = refFormsListTable.value
      ? refFormsListTable.value.localItems.length
      : 0;
    return {
      from: perPage.value * (currentPage.value - 1) + (localItemsCount ? 1 : 0),
      to: perPage.value * (currentPage.value - 1) + localItemsCount,
      of: totalForms.value,
    };
  });

  const refetchData = () => {
    refFormsListTable.value.refresh();
  };

  watch([currentPage, perPage, conditionsFilter], () => {
    refetchData();
  });

  const fetchForms = (ctx, callback) => {
    store
      .dispatch("app-provider-forms/fetchProviderForms", {
        perPage: perPage.value,
        page: currentPage.value,
        sortBy: sortBy.value,
        sortDesc: isSortDirDesc.value,

        conditions: conditionsFilter.value,
      })
      .then((response) => {
        const { forms, total } = response.data;
        callback(forms);
        totalForms.value = total;
      })
      .catch(() => {
        toast({
          component: ToastificationContent,
          props: {
            title: "Error al obtener la lista de formularios",
            icon: "AlertTriangleIcon",
            variant: "danger",
          },
        });
      });
  };

  return {
    fetchForms,
    tableColumns,
    perPage,
    currentPage,
    totalForms,
    dataMeta,
    perPageOptions,
    sortBy,
    isSortDirDesc,
    refFormsListTable,

    refetchData,

    // Extra Filters
    conditionsFilter,
  };
}
